import React from 'react';


export const Whitescreen = ({open}) => {
    return (
        open && (<div style={{position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', backgroundColor: 'white', zIndex: 10000}} />)
    );
};
